import { useEffect, useState } from "react";
import Grid from "./Grid";
import Loader from "../../Tools/Loader";
import NotFound from "./NotFound";
import useAuditStore from "./useAuditStore";
import API from "../../../services/API";
import { useParams } from "react-router-dom";
import Tabs from "./Tabs";
import Improvements from "./Improvements";
import Recommendations from "./Recommendations";

export default function Audit({defaultTab, showTabs}){

    const {course} = useParams()

    const [status, setStatus] = useState('loading')

    const {setup, tab} = useAuditStore()

    useEffect(() => {

        API.get(`/courses/${course}/audit`)
            .then(r => {
                setup(r.data, defaultTab)
                setStatus('ready')
            })
            .catch(_ => setStatus('error'))

    }, [course, setup, defaultTab])

    if(status === 'loading') return <Loader />

    if(status === 'error') return <NotFound />

    return <>

        {showTabs &&
            
            <Tabs />
        }

        {['initial','final'].includes(tab) && 

            <Grid />
        }

        {tab === 'improvements' && 

            <Improvements />
        }
        
        {tab === 'recommendations' && 

            <Recommendations />
        }
        
    
    </>
}